import React from "react";

function Stories() {
  return (
    <div className="p-6 text-center">
      <h2 className="text-3xl font-bold mb-4">📖 Stories</h2>
      <div className="grid md:grid-cols-3 gap-4 justify-center">
        <div className="bg-yellow-300 p-6 rounded-xl text-xl font-bold hover:scale-105 transform transition cursor-pointer">🦄 Magical Unicorn Adventure</div>
        <div className="bg-purple-300 p-6 rounded-xl text-xl font-bold hover:scale-105 transform transition cursor-pointer">🐉 Funny Dragon</div>
        <div className="bg-pink-300 p-6 rounded-xl text-xl font-bold hover:scale-105 transform transition cursor-pointer">🏰 Princess & Robot</div>
      </div>
    </div>
  );
}

export default Stories;
